import gql from 'graphql-tag';
export const userFragment = gql `
  fragment userFields on UserEntity {
    id
    dateOfBirth
    name
    idNumber
    firstName
    lastName
    nationality
    residency
    email
    emailVerifiedAt
    agreedToTerms
    isCardDepositEnabled
    isActive
    isTwoFactorEnabled
    isSmsTwoFactorEnabled
    isEmailTwoFactorEnabled
    officialFirstName
    officialLastName
    frStatus
    isCardDepositEnabled
    country
    city
    address
    nationality
    zip
    phone
    status
    referrerCode
    externalReferrerBalance
    internalReferrerCode
    image
    createdAt
    isZendeskUser
    autoConversionEnabled
    amlComment
    riskLevel
    deletedAt
  }
`;
//# sourceMappingURL=user.js.map